import ChatBot from './chatbot.vue'
//import './styles/chatbot.css'

export default {
    install(app, options = {}) {
        app.provide('chatbotOptions', options)   // global config
        app.component('ChatBot', ChatBot)        // use <ChatBot /> anywhere
    },
}
export { ChatBot }